import styled from 'styled-components';
import { Typography, Tag, Row, Button } from 'antd';

const { Title } = Typography;

export const ContentContainer = styled.div`
	margin-bottom: 24px;
`;

export const ContentTitle = styled(Title).attrs({ level: 4 })`
	margin-bottom: 8px;
`;

export const ContentTag = styled(Tag)`
	margin-bottom: 8px;
	margin-right: 8px;
	font-size: 14px;
	padding: 4px 8px;
	border-radius: 4px;
	background-color: #ebeefd;
	color: #333;
	border: none;
`;

export const GeneralInfoContainer = styled.div`
	margin-bottom: 24px;
`;

export const HeaderRow = styled(Row)`
	margin-bottom: 16px;
`;

export const InfoListContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const InfoItem = styled.div`
	font-size: 16px;
	line-height: 1.5;
	word-break: break-word;
`;

export const InfoLabel = styled.span`
	font-weight: 600;
`;

export const DownloadButton = styled(Button)`
	&.ant-btn {
		&[disabled] {
			background: #f5f5f5;
			border-color: #d9d9d9;
			color: rgba(0, 0, 0, 0.25);
		}
	}
`;

export const GeneralInfoTitle = styled(Title).attrs({ level: 4 })`
	margin: 0;
`;
